<template>
  <v-chip label
          size="small"
          variant="flat"
          class="text-body-2 AppSignedDocumentsSignatureStatus rounded-pill"
          data-locator="file-status"
  >
    <span class="detail-md-bold">{{ $t(`common.AppSignedDocumentsSignatureStatus.${status}`) }}</span>
  </v-chip>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

import { SignatureStatus } from '@/common/utils/signatureStatus'

const STATUS_STYLE_MAP: Record<SignatureStatus, { color: string; backgroundColor: string }> = {
  [SignatureStatus.Sent]: {
    color: 'text-secondary',
    backgroundColor: 'surface-grey-subtle',
  },
  [SignatureStatus.Signed]: {
    color: 'text-warning',
    backgroundColor: 'surface-warning-subtle',
  },
  [SignatureStatus.SignedByAll]: {
    color: 'text-success',
    backgroundColor: 'surface-success',
  },
  [SignatureStatus.Voided]: {
    color: 'text-teal',
    backgroundColor: 'surface-teal-subtle',
  },
}

const DEFAULT_STYLE = { color: 'text-secondary', backgroundColor: 'surface-grey-subtle' }

/**
 * Default Signature status
 * @displayName AppSignedDocumentsSignatureStatus
 */
export default defineComponent({
  name: 'AppSignedDocumentsSignatureStatus',
  props: {
    status: {
      type: String as PropType<SignatureStatus>,
      required: true,
    },
  },
  computed: {
    style (): { color: string; backgroundColor: string } {
      return STATUS_STYLE_MAP[this.status] ?? DEFAULT_STYLE
    },
    color (): string {
      return `rgb(var(--v-theme-${this.style.color}))`
    },
    backgroundColor (): string {
      return `rgb(var(--v-theme-${this.style.backgroundColor}))`
    },
  },
})
</script>
<style scoped lang="scss">
.AppSignedDocumentsSignatureStatus {
  background-color: v-bind(backgroundColor);
  color: v-bind(color);
}
</style>
